export default {
  headers: {
    // Common headers
    result: "Резултат",
    results: "Резултати",
    current: "Тековен",
    examination: "Испитување",
    test: "Тест",
    flag: "Знаме",
    flagText: "Знаме",
    flags: "Знамена",
    refRange: "Реф. опсег",
    units: "Единици",
    resultTime: "Датум / Време",
    history: "Историја",
    actions: "Акции",
    visit_id: "Визита",
    barcode: "Баркод",
    total_results: "Резултати",
    sample_category: "Категорија",
    collection_time: "Земена",
    instrument: "Апарат",
    disk_rack: "Диск/Рафт",
    position: "Позиција",
    sample_number: "Број на примерок",
    sample_type: "Тип примерок",
    sets_count: "Сетови",
    pending_results: "Чекачки",
    approved_results: "Одобрени",
    sample_code: "Код",
    resultsCount: "Бр. резултати",
  },

  no_data: "Нема достапни податоци",

  // Table toolbar
  toolbar: {
    refresh: "Освежи",
    pdf: "Преземи PDF",
    pdfAction: "Преземање",
    email: "Испрати по е-пошта",
    emailAction: "Испраќање",
    moreActions: "Повеќе акции",
  },
};
